import { useEffect } from 'react';
import { useAuthenticatedUser } from 'src/components/Auth/hooks/useAuthenticatedUser';
import { showNotification } from 'src/components/NotificationBanner/showNotification';

export const useLoginPrompt = (timeoutMs = 30000) => {
  const { isAuthenticated } = useAuthenticatedUser();

  const showLoginPrompt = () => {
    showNotification({
      message: "Hey, if you already have a t2 account, don't forget to login to earn time points! ",
      type: 'success',
      title: '',
      displayIcon: false,
    });
  };

  useEffect(() => {
    if (isAuthenticated) {
      return;
    }

    const timeout = setTimeout(showLoginPrompt, timeoutMs);

    return () => clearTimeout(timeout);
  }, [isAuthenticated]);
};
